export const EVENT_TYPE_CODES = {
    FITTING: 'FITTING',
    HQ: 'HQ',
    DEMO: 'DEMO',
    EXTERNAL: 'EXTERNAL',
}

export const WEEKLY_AVAILABILITY_DAYS_LIMIT = 7
